import { categories } from "@/mocks/suye";

const sections = [
  { title: "板块导航", links: [["现场围观", "#live"], ["实时热榜", "#hot"], ["话题分类", "#cats"], ["热门专题", "#feature"], ["常见问题", "#faq"]] },
  { title: "围观广场", links: [["围观讨论", "#square"], ["关于宿野", "#about"], ["订阅速递", "#contact"]] },
];

export default function Footer() {
  const year = 2026;
  return (
    <footer className="bg-background-200/60 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 font-heading text-xl font-black text-background-50">
                瓜
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
                  宿野<span className="text-primary-500">吃瓜</span>
                </span>
                <span className="mt-1 text-[10px] tracking-[0.2em] uppercase text-foreground-500">热点现场围观</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              一个把散落在各处的热点进展、时间线与讨论聚到一起的实时围观社区，让你前排坐稳、来龙去脉都清楚。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-line", "ri-wechat-line", "ri-bilibili-line", "ri-douban-line"].map((ic) => (
                <a
                  key={ic}
                  href="#contact"
                  aria-label="关注宿野"
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={ic + " text-lg"} />
                </a>
              ))}
            </div>
          </div>

          {sections.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map(([label, href]) => (
                  <li key={href}>
                    <a href={href} className="inline-flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-700">
                      <i className="ri-arrow-right-s-line text-foreground-400" />
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-sm font-bold text-foreground-950">话题分类</h4>
            <ul className="mt-4 flex flex-wrap gap-2">
              {categories.map((c) => (
                <li key={c.id}>
                  <a
                    href="#cats"
                    className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
                  >
                    <i className={c.icon + " text-[10px]"} />
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-5 text-xs leading-relaxed text-foreground-500">
              合作与线索邮箱：
              <a href="#contact" className="text-foreground-700 hover:text-primary-700">suye@readdy.example</a>
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© {year} 宿野吃瓜 · 前排坐稳，吃瓜不迷路</p>
          <p>本站内容整理自公开可检索渠道，仅供信息聚合与交流参考。</p>
        </div>
      </div>
    </footer>
  );
}